function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextEditingDocumentEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "text_x5F_editing_x5F_document_x5F_edit",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.62 32",
    style: {
      enableBackground: "new 0 0 29.62 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "8,8 1,8 1,6 6,6 6,1 8,1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "24,32 0,32 0,6.586 6.586,0 24,0 24,8 22,8 22,2 7.414,2 2,7.414 2,30 22,30 22,23 24,23  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M14.414,28H10v-4.414L24.293,9.293c1.217-1.217,3.197-1.217,4.414,0 c1.217,1.217,1.217,3.197,0,4.414L14.414,28z M12,26h1.586l13.707-13.707c0.212-0.212,0.329-0.494,0.329-0.793 s-0.117-0.581-0.329-0.793c-0.425-0.424-1.161-0.424-1.586,0L12,24.414V26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 22.379,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -13.3701 16.7218)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 4.243
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextEditingDocumentEdit);
export default __webpack_public_path__ + "static/media/text_editing_document_edit.1a128378dbb48a7d61110efd70abee8c.svg";
export { ForwardRef as ReactComponent };